import { render, staticRenderFns } from "./InvestorMutualFundItem.vue?vue&type=template&id=fbefd312&scoped=true&"
import script from "./InvestorMutualFundItem.vue?vue&type=script&lang=js&"
export * from "./InvestorMutualFundItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorMutualFundItem.vue?vue&type=style&index=0&id=fbefd312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbefd312",
  null
  
)

export default component.exports